<template>
  <div class="film">
    <div class="title">
      <div>安徽省儿童医院(TEST)</div>
      <div>眼底筛查报告单</div>
    </div>
    <div class="titel_conter">
      <div class="message_title">
        <div class="content">
          检查日期：
          <span class="font-weight">2019/09/27</span>
        </div>
        <div class="content">
          就诊号：
          <span class="font-weight">20199</span>
        </div>
        <div class="content">
          住院号：
          <span class="font-weight">20199</span>
        </div>
      </div>
      <div class="message_conter">
        <div class="content">
          姓名：
          <span class="font-weight">测试</span>
        </div>
        <div class="content">
          性别：
          <span class="font-weight">20199</span>
        </div>
        <div class="content">
          籍贯：
          <span class="font-weight">20199</span>
        </div>
        <div class="content">
          联系电话：
          <span class="font-weight">20199</span>
        </div>
      </div>
      <div class="message_conter">
        <div class="content">
          出生日期：
          <span class="font-weight">20199</span>
        </div>
        <div class="content">
          胎数：
          <span class="font-weight">20199</span>
        </div>
        <div class="content">
          出生胎龄（周）：
          <span class="font-weight">20199</span>
        </div>
        <div class="content">
          矫正胎数：
          <span class="font-weight">20199</span>
        </div>
      </div>
      <div class="message_conter">
        <div class="content">
          出生体重（千克）：
          <span class="font-weight">20199</span>
        </div>
        <div class="content" style="width:50%;">
          出生医院：
          <span class="font-weight">双沙发阿斯顿发阿萨德发送到发送到（2-1）</span>
        </div>
        <div class="content">
          生产方式：
          <span class="font-weight">双沙发阿斯顿</span>
        </div>
      </div>
      <div class="message_title">
        <div class="content">
          吸氧史：
          <span class="font-weight">无</span>
        </div>
        <div class="content">
          家庭病史：
          <span class="font-weight">双沙发阿斯顿发阿萨德发送到发送到（2-1）</span>
        </div>
      </div>
    </div>
    <div class="film_conter">
      <div class="film_img">
        <div>眼底示意图：</div>
        <div class="img_conter">
          <img class="img" src="../../assets/images/film.png" alt />
        </div>
      </div>
      <div class="eye_img">
        <div>眼部照片：</div>
        <div class="img_conter">
          <img src="../../assets/images/film1.jpg" alt />
          <img src="../../assets/images/film1.jpg" alt />
        </div>
      </div>
      <div class="describe">
        <div>眼部照片：</div>
        <div class="describe_text">左眼描述00000</div>
        <div class="describe_text">右眼描述00000</div>
      </div>
      <div class="describe">
        <div>医嘱：</div>
        <div class="describe_text">医嘱：长期随访；家长及儿科医生注意视功能发育</div>
        <div class="describe_text">用药：</div>
        <div class="describe_text">用药：</div>
        <div class="describe_text">复诊：</div>
      </div>
      <div class="describe">
        <div>诊断：</div>
        <div class="describe_text">双眼文件异常</div>
      </div>
    </div>
    <div class="footer">
      <div class="message_title">
        <div class="content">
          操作人员：
          <span class="font-weight">阿道夫</span>
        </div>
        <div class="content">
          医生签名：
          <span class="font-weight">20199</span>
        </div>
        <div class="content">
          报告日期：
          <span class="font-weight">20199</span>
        </div>
      </div>
      <div class="remarks">注：本诊断仅说明宝宝目前的眼睛状况，不代表后期的变化。医生建议：严格按照复诊时间进行复查。</div>
    </div>
  </div>
</template>

<script>
import util from "@/utils";
import { forgetPassword, getCaptcha } from "@/api/index.js";
export default {
  name: "",
  components: {},
  props: {},
  data() {
    return {};
  },
  methods: {}
};
</script>

<style lang="scss" scoped>
.film {
  width: 60%;
  height: 100%;
  margin: 0 auto;
  .title {
    padding-top: 50px;
    text-align: center;
    div:nth-child(1) {
      font-size: 25px;
    }
    div:nth-child(2) {
      margin-top: 20px;
      font-size: 20px;
      font-weight: 600;
    }
  }
  .titel_conter {
    margin-top: 40px;
    width: 100%;
    height: 20%;
    .message_title {
      font-weight: 700;
      padding-bottom: 10px;
      border-bottom: 2px solid #000;
      display: flex;
      align-content: center;
      .content:nth-child(1) {
        width: 25%;
      }
      .content:nth-child(2) {
        width: 50%;
      }
      .content:nth-child(3) {
        width: 25%;
      }
    }
    .message_conter {
      font-weight: 700;
      margin-top: 10px;
      padding-bottom: 10px;
      display: flex;
      align-content: center;
      .content:nth-child(1) {
        width: 25%;
      }
      .content:nth-child(2) {
        width: 25%;
      }
      .content:nth-child(3) {
        width: 25%;
      }
      .content:nth-child(4) {
        width: 25%;
      }
    }
  }
  .film_conter {
    // margin-top: 10px;
    .img_conter {
      width: 100%;
      height: 100%;
      display: flex;
      align-content: center;
      justify-content: center;
      .img {
        width: 500px;
        height: 200px;
      }
    }
    .eye_img {
      margin-top: 30px;
      .img_conter {
        width: 100%;
        height: 100%;
        display: flex;
        align-content: center;
        justify-content: center;
        img {
          margin-left: 30px;
          width: 250px;
          height: 200px;
        }
      }
    }
    .describe {
      .describe_text {
        margin-top: 10px;
        margin-bottom: 10px;
        text-indent: 25px;
      }
    }
  }
  .footer {
    margin-top: 40px;
    width: 100%;
    height: 20%;
    .message_title {
      font-weight: 700;
      padding-top: 10px;
      border-top: 2px solid #000;
      display: flex;
      align-content: center;
      .content:nth-child(1) {
        width: 33.3%;
      }
      .content:nth-child(2) {
        width: 33.3%;
      }
      .content:nth-child(3) {
        width: 33.3%;
      }
    }
    .remarks {
      margin-top: 10px;
      font-size: 15px;
      color: #606266;
    }
  }
  .font-weight {
    font-weight: 500;
  }
}
</style>
